@if ((assistant.available$ | async) && !(assistant.open | async)) {
  @let pending = (assistant.pendingCount$ | async) || 0;
  <button type="button" class="launcher" [class.is-intro]="intro" [class.is-nudging]="nudge && !intro"
    (click)="assistant.open.next(true)"
    [matTooltip]="'Assistente AI' | translate" matTooltipPosition="left" [matTooltipDisabled]="intro"
    [attr.aria-label]="(pending ? 'Assistente AI: proposte da confermare' : 'Assistente AI') | translate">
    <span class="launcher__label" aria-hidden="true">{{ 'Chiedi all\'assistente' | translate }}</span>
    <mat-icon class="launcher__icon" fontSet="material-icons-round">auto_awesome</mat-icon>
    @if (pending) {
      <span class="launcher__badge" aria-hidden="true">{{ pending }}</span>
    }
  </button>
}
